import { createState, useState, State } from '@hookstate/core';

interface ICreateTicketState {
  equipmentId: string;
  open: boolean;
}

const createTicketState = createState<ICreateTicketState>({
  open: false,
  equipmentId: '',
});

const wrapState = (state: State<ICreateTicketState>) => ({
  ...state,
  toggleCreateTicket: () => {
    state.open.set(oldState => !oldState);
  },
  openCreateTicket: () => {
    state.open.set(true);
  },
  closeCreateTicket: () => {
    state.open.set(false);
  },
});

const useCreateTicketState = () => wrapState(useState(createTicketState));

export { createTicketState, useCreateTicketState };
